import React, { Component } from 'react';
import { connect } from 'react-redux';
import ExportModal from './components/ExportModal';
import Header from './components/Header';
import Filter from './components/Filter';
import List from './components/List';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import '../style/home.less';
import { saveSearchParams } from '../../../actions/rankActions';
import format from '../../shared/format';
import moment from 'moment';

const monthFormat = 'YYYY-MM';

class TeachingRank extends Component {
    constructor(props) {
        super(props);
        const { match: { params: { date } }, performanceState } = this.props;
        const { params, pagination } = performanceState || {};
        const currentDate = date ? moment(date).format(monthFormat) : undefined;
        this.state = {
            searchParams: {
                date: currentDate,
                ...params,
            },
            pagination: {
                current: 1,
                pageSize: 10,
                ...pagination,
            },
            loading: false,
            data: [],
            maxDate: '',
            meanValue: 0,
        };
    }

    componentDidMount() {
        this.queryEffectiveDate();
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            Fetch.post(API_URL.home.queryEffectiveDate)
                .then(cb);
        }, res => {
            const { year, month } = res;
            const maxDate = format('month', year, month);
            let monthDate = maxDate;
            if (month >= 6 && month < 12) {
                monthDate = format('month', year, 6);
            } else if (month >= 1 && month < 6) {
                monthDate = format('month', year - 1, 12);
            }
            this.defaultDate = monthDate;
            this.setState({
                maxDate,
                date: this.defaultDate,
            }, () => {
                this.loadData();
            });
        });
    }

    loadData = () => {
        const { pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        const { areaParams = {}, hasCheckedArea,  areaName, ...restParams } = searchParams;

        this.setState({ loading: true });
        Fetch.post(API_URL.home.queryPerformanceUserScoreByType,  {
            offset: current,
            limit: pageSize,
            ...restParams,
            ...areaParams,
        }).then(res => {
            const { datas, totalCount } = res.result;
            pagination.total = totalCount;
            this.setState({
                pagination,
                data: datas,
                loading: false,
                meanValue: res.avg,
            });
        }).catch(() => {
            this.setState({ loading: false });
        });
    }

    handleReset = () => {
        this.setState({
            searchParams: { date: this.defaultDate },
            pagination: {
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.loadData();
        });
    }

    handleExport = () => {
        this.exportRef.show();
    }

    handleSearch = () => {
        const { pagination } = this.state;
        this.setState({
            pagination: {
                ...pagination,
                current: 1,
            }
        }, () => {
            this.loadData();
        });
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    handleListChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    showDetail = (record) => {
        const {  saveParams, history } = this.props;
        const { maxDate, searchParams, pagination } = this.state;
        saveParams({
            maxDate,
            pagination,
            userId: record.userId,
            params: { ...searchParams },
            userCompellation: record.userCompellation,
            employeeCode: record.employeeCode,
        });
        history.push('/teachingDetail');
    }

    render() {
        const { searchParams, pagination, data, meanValue, maxDate } = this.state;
        return (
            <div className="container">
                <div className="full whole-page">
                    <Header />
                    <Filter
                        maxDate={maxDate}
                        searchParams={searchParams}
                        onReset={this.handleReset}
                        onExport={this.handleExport}
                        onSearch={this.handleSearch}
                        onChange={this.handleFilterChange}
                    />
                    <List
                        data={data}
                        meanValue={meanValue}
                        pagination={pagination}
                        showDetail={this.showDetail}
                        onChange={this.handleListChange}
                    />
                    <ExportModal ref={el => this.exportRef = el} pagination={pagination} searchParams={searchParams} />
                </div>
            </div>
        );
    }
}

const mapSateToProps = (state) => ({
    performanceState: state.rankState.params || {},
});

const mapDispatchToProps = (dispatch) => ({
    saveParams: (params) => dispatch(saveSearchParams(params))
});

export default connect(mapSateToProps, mapDispatchToProps)(TeachingRank);


// WEBPACK FOOTER //
// ./src/components/home/TeachingRank/index.js